import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import createFAIcon from './createFAIcon';

const PlayIcon = createFAIcon(solid('pause'));
export default PlayIcon;
